<div
  class="accordion-element-container"
  [ngClass]="[isFirstElement() ? 'accordion-element' : 'accordion-element-without-border-top', accordionSpacerClass()]">
  <a
    href="javascript:void(0)"
    class="row justify-content-between list-group-item gast-list-group-item"
    [ngClass]="isCurrentlyCollapsed() ? 'collapsed' : ''"
    (click)="click()">
    @if (leftImage()) {
      <div class="col-10 col-md-11 imageDiv">
        <img [alt]="'GAST-PORTAL-NG.ACCORDION_ELEMENT.IMAGE' | translate" [src]="leftImage()" />
      </div>
    }

    @if (leftIcon()) {
      <div class="col-1 col-md-1">
        <i leftIcon [ngClass]="!leftImage() && !leftIcon() ? 'fas fa-file-alt fa-3x' : leftIcon()"></i>
      </div>
    }

    @if (label()) {
      <div
        class="heading"
        [ngClass]="labelClass()"
        [class.bold-heading]="isHeadingBold()"
        [innerHtml]="useTranslation() ? (label() | translate) : label()"></div>
    }

    @if (icon1() && icon2()) {
      <div class="col-2 col-md-2">
        <img [alt]="'GAST-PORTAL-NG.ACCORDION_ELEMENT.ICON' | translate" id="icon1" [src]="icon1()" />
        @if (icon2()) {
          <i id="icon2" class="col-1 col-md-1" icon1 [ngClass]="!icon2() ? 'fas fa-file-alt fa-2x' : icon2()"></i>
        }
      </div>
    }

    <div class="col-2 col-md-1 collapsed-indicator" style="text-align: end">
      <i
        class="fas fa-chevron-down"
        [ngClass]="{
          expanded: !isCurrentlyCollapsed(),
        }"></i>
    </div>
  </a>

  <div class="content-container" [attr.id]="id()" [collapse]="isCurrentlyCollapsed()">
    <ng-content class="collapse"></ng-content>
  </div>
</div>
